import type { GetServerSidePropsContext } from 'next';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageCon from '@/components/SmsSubscribe';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

export default function Page({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('smssubscribe');
    const router = useRouter();
    const { locale = 'us' } = router;

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['eu', 'uk', 'de', 'fr', 'it', 'es']} locale={locale} pathname={'sms-subscribe'} />
            <PageLayout className={`${css.productcontent}  product_common product_common_real`}>
                <PageCon />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    const whiteLocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
